import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { Doughnut } from 'react-chartjs-2'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'

import { SUBSCRIBER_GENRE } from '../../constants/module_info'
import { TOPLINE_GENRE, SUBSCRIBER_NETWORK_TYPE_DEFAULT1, SUBSCRIBER_NETWORK_TYPE_DEFAULT2, SUBSCRIBER_NETWORK_TYPE_PRIMARY,
  SUBSCRIBER_SORT_TYPE_PRIMARY, SUBSCRIBER_SORT_TYPE_DEFAULT1, SUBSCRIBER_SORT_TYPE_DEFAULT2, NONE } from '../../constants/commons'

export class SubscriberGenreComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    selectedNetwork: PropTypes.string,
    selectedNetworkType: PropTypes.string,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    subscriber: PropTypes.object,
    selectedGenre: PropTypes.string,
    setSelectedGenre: PropTypes.func,
    setPercentageByGenre: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetwork: null,
      defaultNetwork1: null,
      defaultNetwork2: null,
      page: 0,
      data: [],
      primaryNetworkData: [],
      defaultNetwork1Data: [],
      defaultNetwork2Data: [],
      selectedGenreIndex: -1,
      backgroundColor: [
        '#1145A1',
        '#665191',
        '#A05195',
        '#D45087',
        '#F95D6A',
        '#FF7C43',
        '#FFA600',
        '#FFC700',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B',
        '#FFF27B'
      ],
      backgroundColorOpacity: [
        'rgba(17,69,161, 0.4)',
        'rgba(102,81,145, 0.4)',
        'rgba(160,81,149, 0.4)',
        'rgba(212,80,135, 0.4)',
        'rgba(249,93,106, 0.4)',
        'rgba(255,124,67, 0.4)',
        'rgba(255,166,0, 0.4)',
        'rgba(255,199,0, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)',
        'rgba(255,242,123, 0.4)'
      ]
    }
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.subscriber !== this.props.subscriber && this.props.subscriber.details && this.props.subscriber.details.percentage_by_genre) || (this.props.subscriber.details &&
      (prevProps.primaryNetwork !== this.props.primaryNetwork && this.props.primaryNetwork) ||
      (prevProps.defaultNetwork1 !== this.props.defaultNetwork1 && this.props.defaultNetwork1) ||
      (prevProps.defaultNetwork2 !== this.props.defaultNetwork2 && this.props.defaultNetwork2))) {
      const percentageByGenre = this.props.subscriber.details.percentage_by_genre
      const primaryNetwork = this.props.primaryNetwork && percentageByGenre.filter(n => n.data && n.data.data[0].network === this.props.primaryNetwork.network)[0]
      const defaultNetwork1 = this.props.defaultNetwork1 && percentageByGenre.filter(n => n.data && n.data.data[0].network === this.props.defaultNetwork1.network)[0]
      const defaultNetwork2 = this.props.defaultNetwork2 && percentageByGenre.filter(n => n.data && n.data.data[0].network === this.props.defaultNetwork2.network)[0]
      const data = []
      const primaryNetworkData = []
      const defaultNetwork1Data = []
      const defaultNetwork2Data = []
      let primaryNetworkPercentage = 0
      let defaultNetwork1Percentage = 0
      let defaultNetwork2Percentage = 0
      TOPLINE_GENRE.split(',').map((e, index) => {
        primaryNetworkPercentage = (primaryNetwork && primaryNetwork.data) && primaryNetwork.data.data.filter(n => n.genre === e)[0].genreNetworkPercentage
        defaultNetwork1Percentage = (defaultNetwork1 && defaultNetwork1.data) && defaultNetwork1.data.data.filter(n => n.genre === e)[0].genreNetworkPercentage
        defaultNetwork2Percentage = (defaultNetwork2 && defaultNetwork2.data) && defaultNetwork2.data.data.filter(n => n.genre === e)[0].genreNetworkPercentage
        data.push({
          id: index,
          genre: e,
          primaryNetwork: Math.round(primaryNetworkPercentage),
          defaultNetwork1: Math.round(defaultNetwork1Percentage),
          defaultNetwork2: Math.round(defaultNetwork2Percentage),
          bg: this.state.backgroundColor[index < 8 ? index : 8]
        })
      })
      data.slice(0).sort((a, b) => b.primaryNetwork - a.primaryNetwork).map((d, i) => {
        primaryNetworkData.push({
          index: i,
          bg: this.state.backgroundColor[i],
          genre: d.genre,
          primaryNetwork: d.primaryNetwork
        })
      })
      data.slice(0).sort((a, b) => b.defaultNetwork1 - a.defaultNetwork1).map((d, i) => {
        defaultNetwork1Data.push({
          index: i,
          bg: this.state.backgroundColor[i],
          genre: d.genre,
          defaultNetwork1: d.defaultNetwork1
        })
      })
      data.slice(0).sort((a, b) => b.defaultNetwork2 - a.defaultNetwork2).map((d, i) => {
        defaultNetwork2Data.push({
          index: i,
          bg: this.state.backgroundColor[i],
          genre: d.genre,
          defaultNetwork2: d.defaultNetwork2
        })
      })
      this.setState({
        data: data,
        primaryNetworkData: primaryNetworkData,
        defaultNetwork1Data: defaultNetwork1Data,
        defaultNetwork2Data: defaultNetwork2Data
      })
      this.props.setPercentageByGenre(data, primaryNetworkData, defaultNetwork1Data, defaultNetwork2Data)
    }
  }

  setSelectedGenreIndex = (index) => {
    this.setState({ selectedGenreIndex: index })
  }

  render () {
    const { classes, selectedNetwork, primaryNetwork, defaultNetwork1, defaultNetwork2 } = this. props
    const networkClassName = primaryNetwork && primaryNetwork.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_PRIMARY :
    defaultNetwork1 && defaultNetwork1.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_DEFAULT1 :
    defaultNetwork2 && defaultNetwork2.network === selectedNetwork ? SUBSCRIBER_NETWORK_TYPE_DEFAULT2 : ''
    return (
      <Paper className={`infoBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`infoBoxTitle ${classes.cardTitle}`}>Percentages by Genre</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{SUBSCRIBER_GENRE}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
          <Grid item className={`infoSub ${classes.cardSubTitle}`}>Genre by content catalog for <span className={networkClassName}>{selectedNetwork}</span></Grid>
        </Grid>
        <Grid container className='catalogDoughnut'>
          <Grid item xl={4} lg={4} md={2} sm={12} xs={12}>
            <TypeView
              details={this.state.data}
              backgroundColor={this.state.backgroundColor}
              backgroundColorOpacity={this.state.backgroundColorOpacity}
              selectedNetworkType={this.props.selectedNetworkType}
              selectedGenre={this.props.selectedGenre}
              setSelectedGenre={this.props.setSelectedGenre}
              selectedGenreIndex={this.state.selectedGenreIndex}
              setSelectedGenreIndex={this.setSelectedGenreIndex}
            />
          </Grid>
          <Grid item xl={8} lg={8} md={10} sm={12} xs={12}>
            <TableView
              classes={this.props.classes}
              page={this.state.page}
              details={this.state.data}
              primaryNetworkData={this.state.primaryNetworkData}
              defaultNetwork1Data={this.state.defaultNetwork1Data}
              defaultNetwork2Data={this.state.defaultNetwork2Data}
              backgroundColor={this.state.backgroundColor}
              selectedNetworkType={this.props.selectedNetworkType}
              primaryNetwork={this.props.primaryNetwork}
              defaultNetwork1={this.props.defaultNetwork1}
              defaultNetwork2={this.props.defaultNetwork2}
              selectedGenre={this.props.selectedGenre}
              setSelectedGenre={this.props.setSelectedGenre}
              setSelectedGenreIndex={this.setSelectedGenreIndex}
            />
          </Grid>
        </Grid>
      </Paper>
    )
  }
}

class TypeView extends React.Component {
  static propTypes = {
    details: PropTypes.array.isRequired,
    backgroundColor: PropTypes.array.isRequired,
    backgroundColorOpacity: PropTypes.array.isRequired,
    selectedNetworkType: PropTypes.string,
    selectedGenre: PropTypes.string,
    setSelectedGenre: PropTypes.func,
    selectedGenreIndex: PropTypes.number,
    setSelectedGenreIndex: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      data: [],
      labels: [],
      backgroundColor: [],
      totalGenreCount: 0
    }
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.details !== this.props.details && this.props.details) || (this.props.details && prevProps.selectedNetworkType !== this.props.selectedNetworkType)) {
      if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY) {
        let data = this.props.details
        data = data.sort((a, b) => b.primaryNetwork - a.primaryNetwork).sort((a, b) => a.genre - b.genre)
        this.setState({
          data: data.map(e => e.primaryNetwork),
          labels: data.map(e => e.genre),
          backgroundColor: data.map(e => e.bg)
        })
      } else if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1) {
        let data = this.props.details
        data = data.sort((a, b) => b.defaultNetwork1 - a.defaultNetwork1).sort((a, b) => a.genre - b.genre)
        this.setState({
          data: data.map(e => e.defaultNetwork1),
          labels: data.map(e => e.genre),
          backgroundColor: data.map(e => e.bg)
        })
      } else if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2) {
        let data = this.props.details
        data = data.sort((a, b) => b.defaultNetwork2 - a.defaultNetwork2).sort((a, b) => a.genre - b.genre)
        this.setState({
          data: data.map(e => e.defaultNetwork2),
          labels: data.map(e => e.genre),
          backgroundColor: data.map(e => e.bg)
        })
      }
    }
  }

  setSelectedGenre = (genre, index) => {
    this.props.setSelectedGenre(this.props.selectedGenre === genre ? null : genre)
    this.props.setSelectedGenreIndex(index)
  }

  render () {
    let backgroundColor = this.props.selectedGenre ? this.props.backgroundColorOpacity.slice(0) : this.props.backgroundColor.slice(0)
    if (this.props.selectedGenre && this.props.selectedGenreIndex > -1) {
      backgroundColor = this.props.backgroundColorOpacity.slice(0)
      backgroundColor[this.props.selectedGenreIndex] = this.props.backgroundColor[this.props.selectedGenreIndex]
    }
    const chartdata = {
      datasets: [
        {
          backgroundColor: backgroundColor,
          data: this.state.data,
          label: this.state.labels
        }
      ]
    }
    const options = {
      maintainAspectRatio: true,
      responsive: true,
      legend: {
        display: false,
        position: 'right',
        labels: {
          boxWidth: 12,
          pointStyle: 'circle',
          usePointStyle: true,
          fontSize: 14,
          fontFamily: 'Uni Sans Regular'
        }
      },
      datalabels: {
        display: true,
        color: 'white'
      },
      tooltips: {
        enabled: false,
        backgroundColor: '#5a6e7f'
      },
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      cutoutPercentage: 60,
      onClick: (event, elements) => {
        const model = elements[0] ? elements[0]._model : null
        const label = model ? model.label : null
        if (elements[0] && elements[0]._model) {
          const index = elements[0] ? elements[0]._index : 0
          this.setSelectedGenre(label, index)
        }
      }
    }

    return (
      <Box className="anticipationPie">
        <Doughnut data={chartdata} options={options} width={15} height={15}/>
      </Box>
    )
  }
}

export class TableView extends React.Component {
  static propTypes = {
    details: PropTypes.array.isRequired,
    primaryNetworkData: PropTypes.array,
    defaultNetwork1Data: PropTypes.array,
    defaultNetwork2Data: PropTypes.array,
    backgroundColor: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    selectedNetworkType: PropTypes.string,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    selectedGenre: PropTypes.string,
    setSelectedGenre: PropTypes.func,
    setSelectedGenreIndex: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      rowsPerPage: 5,
      order: 'asc',
      orderBy: SUBSCRIBER_SORT_TYPE_PRIMARY
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedNetworkType !== this.props.selectedNetworkType) {
      this.setState( {
        order: 'asc',
        orderBy: this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY ? SUBSCRIBER_SORT_TYPE_PRIMARY :
        this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1 ? SUBSCRIBER_SORT_TYPE_DEFAULT1 : SUBSCRIBER_SORT_TYPE_DEFAULT2
      })
    }
  }

  descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => -this.descendingComparator(a, b, orderBy)
      : (a, b) => this.descendingComparator(a, b, orderBy)
  }

  sortData = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    return stabilizedThis.map((el) => el[0])
  }

  createSortHandler = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc'
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    })
  }

  setSelectedGenre = (genre) => {
    this.props.setSelectedGenre(this.props.selectedGenre === genre ? null : genre)
    let selectedGenre = null
    let selectedGenreIndex = -1
    if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY) {
      selectedGenre = this.props.primaryNetworkData && this.props.primaryNetworkData.filter(d => d.genre === genre)
    } else if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1) {
      selectedGenre = this.props.defaultNetwork1Data && this.props.defaultNetwork1Data.filter(d => d.genre === genre)
    } else if (this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2) {
      selectedGenre = this.props.defaultNetwork2Data && this.props.defaultNetwork2Data.filter(d => d.genre === genre)
    }
    selectedGenreIndex = selectedGenre && selectedGenre.length > 0 ? selectedGenre[0].index : -1
    this.props.setSelectedGenreIndex(selectedGenreIndex)
  }

  render () {
    const primaryNetwork = this.props.primaryNetwork && this.props.primaryNetwork.network
    const defaultNetwork1 = this.props.defaultNetwork1 && this.props.defaultNetwork1.network
    const defaultNetwork2 = this.props.defaultNetwork2 && this.props.defaultNetwork2.network
    const rows = this.props.details
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)
    return (
      <>
        <TableContainer className="mt-2 commonTable newTable genreTable" id="genreTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell>Genre </StyledTableCell>
                <StyledTableCell className="primaryTableLabel" sortDirection={this.state.orderBy === SUBSCRIBER_SORT_TYPE_PRIMARY ? this.state.order : false}>
                  <TableSortLabel
                    active={this.state.orderBy === SUBSCRIBER_SORT_TYPE_PRIMARY}
                    direction={this.state.orderBy === SUBSCRIBER_SORT_TYPE_PRIMARY ? this.state.order : 'asc'}
                    onClick={() => this.createSortHandler(SUBSCRIBER_SORT_TYPE_PRIMARY)}
                  >
                    {primaryNetwork}
                  </TableSortLabel>
                </StyledTableCell>
                { defaultNetwork1 !== NONE &&
                  <StyledTableCell className="defaultOneTableLabel" sortDirection={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT1 ? this.state.order : false}>
                    <TableSortLabel
                      active={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT1}
                      direction={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT1 ? this.state.order : 'asc'}
                      onClick={() => this.createSortHandler(SUBSCRIBER_SORT_TYPE_DEFAULT1)}
                    >
                      {defaultNetwork1}
                    </TableSortLabel>
                  </StyledTableCell>
                }
                { defaultNetwork2 !== NONE &&
                  <StyledTableCell align="right" className="defaultTwoTableLabel" sortDirection={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT2 ? this.state.order : false}>
                    <TableSortLabel
                      active={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT2}
                      direction={this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT2 ? this.state.order : 'asc'}
                      onClick={() => this.createSortHandler(SUBSCRIBER_SORT_TYPE_DEFAULT2)}
                    >
                      {defaultNetwork2}
                    </TableSortLabel>
                  </StyledTableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {this.sortData(rows, this.getComparator(this.state.order, this.state.orderBy))
                .map((row) => {
                  const bgIndex = this.state.orderBy === SUBSCRIBER_SORT_TYPE_PRIMARY ? this.props.primaryNetworkData.filter(g => g.genre === row.genre) : this.state.orderBy === SUBSCRIBER_SORT_TYPE_DEFAULT1 ? this.props.defaultNetwork1Data.filter(g => g.genre === row.genre) : this.props.defaultNetwork2Data.filter(g => g.genre === row.genre)
                  return (
                    <TableRow key={row.id}>
                      <TableCell><Box style={{width: '30px', height: '30px', background: `${bgIndex[0].bg}`}}/></TableCell>
                      <TableCell className={this.props.selectedGenre && this.props.selectedGenre !== row.genre ? 'unSelectedCell' : ''} onClick={() => this.setSelectedGenre(row.genre)}>{row.genre}</TableCell>
                      <TableCell className={(this.props.selectedGenre && this.props.selectedGenre === row.genre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY) || (!this.props.selectedGenre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_PRIMARY) ? 'selectedRow' : ''}>{row.primaryNetwork}%</TableCell>
                      { defaultNetwork1 !== NONE &&
                        <TableCell className={(this.props.selectedGenre && this.props.selectedGenre === row.genre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1) || (!this.props.selectedGenre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT1) ? 'selectedRow' : ''}>{row.defaultNetwork1}%</TableCell>
                      }
                      { defaultNetwork2 !== NONE &&
                        <TableCell className={(this.props.selectedGenre && this.props.selectedGenre === row.genre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2) || (!this.props.selectedGenre && this.props.selectedNetworkType === SUBSCRIBER_NETWORK_TYPE_DEFAULT2) ? 'selectedRow' : ''} align="right">{row.defaultNetwork2}%</TableCell>
                      }
                    </TableRow>
                  )
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}


export default withStyles(styles)(SubscriberGenreComponent)
